module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sailing@3x_3e610c.jpg";